<div style="margin:30px 0;">
  <ng-container *ngIf="!eventService.loadEventTournaments;else loading">

    <mat-tab-group class="orange-ramadan-tabs">

      <mat-tab label="tab2">
        <ng-template mat-tab-label>
          ترتيب الفرق
          <!--<i class="icon icon-shield"></i>-->
        </ng-template>

        <div class="container">
          <ng-container *ngIf="!load;else loading">
            <div class="group_container" *ngIf="!notStarted;else nodata">

              <perfect-scrollbar class="matches-groups-scrollable">
                <ul>
                  <div class="group_header">
                    <div class="flex_block column " style="width:100%;">
                      <div class="flex_block row mid">
                        <h1 style="flex-grow:1;">
                          Final Score
                        </h1>
                        <a href="https://www.gbarena.com/tournaments/rNXcZIT4l6ii/bracket/ranking?game=fortnite&arena=yalla-esports"
                           target="_blank" class="go_button white sm square" style="height:30px; margin:0 10px; font-family: 'proxima_nova_rgregular'; " >
                          <i class="icon-link-ext"></i> All Matches
                        </a>
                      </div>
                    </div>
                  </div>

                  <ul class="group_items" style="flex-flow: row; align-items: center; background:#ececec !important; color:#ae0f67;
                        font-family: proxima-nova-bold-webfont, 'GE_Dinar_Two_Medium'; border-bottom:0;">
                    <li style="width:20px;"></li>
                    <li style="width:20px;">#</li>
                    <li style=" justify-content: flex-start"> Country</li>
                    <li style="flex-grow:6; justify-content: flex-start">Team Name</li>

                    <li class="group-label-container">Average Rank</li>
                    <li class="group-label-container">Total Kills</li>
                    <li class="group-label-container">
                      Total Points
                    </li>

                  </ul>
                  <mat-accordion>
                    <mat-expansion-panel (opened)="panelOpenState = true"
                                         (closed)="panelOpenState = false"
                      *ngFor="let participant of this.RankGroups[0].participants | participantSort:'FreeForAll':this.RankGroups[0].bo3;let index=index">
                      <mat-expansion-panel-header>
                        <ul class="group_items">

                          <mat-panel-title>
                            <li style="width:20px; color:#c8c5c5; justify-content: center; margin:0 10px;">
                              <i class="glyphicon {{panelOpenState ? 'glyphicon-chevron-up' : 'glyphicon-chevron-down'}}"></i>
                            </li>
                            <li style="width:20px;">{{index + 1}} </li>
                            <li style="align-items: center;  justify-content: flex-start">
                              <img class="playerflag"
                                   src="assets/img/flags/{{globalService.getCountryAbbr(participant?.original.country)}}.svg">
                            </li>
                            <li
                              style="align-items: center; flex-grow: 6; text-transform: uppercase; font-family: 'proxima-nova-bold-webfont'; justify-content: flex-start">
                              {{participant.original?.participant_name}}
                            </li>
                          </mat-panel-title>
                          <mat-panel-description>

                            <li style="align-items: center; justify-content: flex-end;width: 100%">


                              <div class="value-container">
                                {{participant.average_rank ?
                                participant.average_rank : 0}}
                              </div>

                              <div class="value-container">
                                {{participant.total_kills ?
                                participant.total_kills : 0}}
                              </div>

                              <div class="value-container">
                                {{participant.score ?
                                participant.score : 0}}
                              </div>
                            </li>
                          </mat-panel-description>

                        </ul>
                      </mat-expansion-panel-header>
                      <div *ngFor="let teamMember of participant['tournament_participant']['tournament_members']"
                           class="team" style="padding: 5px; border-radius: 5px; background: #fff; min-width:140px;">
                        <div style="align-items: center;  justify-content: flex-start">
                          <img class="playerflag" style="width:30px !important; height:30px; border-radius:180px !important; margin:0 10px;" [src]="teamMember.original?.avatar" alt="{{teamMember.original?.participant_name}}">
                        </div>
                        <div
                          style="color: #333333; font-size:12px; display: inline-flex;align-items: center; flex-grow: 6; font-family: 'proxima_nova_rgregular'; justify-content: flex-start">
                          {{teamMember.original?.username}}
                        </div>
                        <a href="https://gbarena.com/gamer/{{teamMember.original?.slug}}"
                           target="_blank"><i class="icon-link-ext" style="height: 30px; background: #ae0f67; display: flex; justify-content: center;
                        align-items: center; margin: 0 5px; border-radius: 3px; color: #fff; font-size: 10px; padding: 0 8px;"></i>
                        </a>
                      </div>
                      <a href="https://gbarena.com/teams/{{participant?.participant_id}}/summary"
                         target="_blank" class="go_button white sm square" style="height:30px; margin:0 10px; float:right; background: #fdc006 !important;
    color: #6b5100 !important; font-family: 'proxima_nova_rgregular';" >
                       Team Profile
                      </a>
                    </mat-expansion-panel>
                  </mat-accordion>

                </ul>

              </perfect-scrollbar>
            </div>

            <ng-template #nodata>
              <div class="no-data">
                <p>
                  البطولة لم تبداء بعد
                </p></div>
            </ng-template>
          </ng-container>
        </div>


      </mat-tab>

      <mat-tab label="tab2">
        <ng-template mat-tab-label>
          <!--<i class="icon-trophy"></i>-->
          البث المباشر
        </ng-template>

        <div class="container flex_block mid column">
<h1>Kemuda</h1>
          <a href="https://www.twitch.tv/kemuda/" target="_blank"
             style="color:#de268c">https://www.twitch.tv/kemuda/</a>
          <div class="frame">
            <iframe src="https://player.twitch.tv/?channel=kemuda&parent=events.gbarena.com"
                    frameborder="0"
                    allowfullscreen="true" scrolling="no" height="300" width="100%"></iframe>
          </div>
        </div>
      </mat-tab>

      <!--      <mat-tab label="tab2" id="test">-->
      <!--        <ng-template mat-tab-label>-->
      <!--          &lt;!&ndash;<i class="icon-trophy"></i>&ndash;&gt;-->
      <!--          الفائزين-->
      <!--        </ng-template>-->

      <!--        <div class="container">-->
      <!--          <div class="no-data">-->
      <!--            <p>-->
      <!--              لم يتم إعلان الفائزين بعد-->
      <!--            </p>-->
      <!--          </div>-->

      <!--        </div>-->
      <!--      </mat-tab>-->

    </mat-tab-group>

    <div class="_footer">
      <a href="https://www.gbarena.com" target="_blank" class="gbarena"><img src="assets/img/GBarena-type.svg"
                                                                             style="width: 80px" alt="GBarena Logo"></a>
      <p>THE ARABIAN WORLD CUP event is hosted on GBarena <br> ALL TERMS & CONDITIONS APPLY</p>
    </div>
  </ng-container>
  <ng-template #loading>
    <app-loading-indicator></app-loading-indicator>
  </ng-template>
</div>
